import React, { createContext, useContext, useState } from 'react';
import AuthModal from './components/AuthModal';

const AuthModalContext = createContext({});

export function AuthModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [initialMode, setInitialMode] = useState('login');
  const [reason, setReason] = useState(null);

  const openAuthModal = (action, mode = 'login', reasonArg = null) => {
    setPendingAction(() => action || null);
    setInitialMode(mode);
    setReason(reasonArg);
    setOpen(true);
  };

  const closeAuthModal = () => {
    setOpen(false);
    setPendingAction(null);
  };

  const handleSuccess = () => {
    setOpen(false);
    if (pendingAction) { pendingAction(); setPendingAction(null); }
  };

  return (
    <AuthModalContext.Provider value={{ openAuthModal, closeAuthModal }}>
      {children}
      {open && <AuthModal onClose={closeAuthModal} onSuccess={handleSuccess} initialMode={initialMode} reason={reason} />}
    </AuthModalContext.Provider>
  );
}

export const useAuthModal = () => useContext(AuthModalContext);
